import React from "react";
import { createGlobalStyle } from "styled-components";

/**
 * Customer-stack surrounding theme.
 *
 * Unlike vault's `VaultTheme` (`--ab*` teal palette), this is the DEFAULT theme
 * for every customer-stack interface: the manager `ColorProvider` dark-navy/blue
 * palette, applied with no additional global override variables (spec §4.2).
 *
 * Deliberately minimal for M0 — this only exists so the wrapping structure
 * (`ColorProvider` -> `CustomerTheme` -> routed content) is in place for later
 * milestones. M1 layers a route-scoped `VaultTheme`-equivalent wrapper around
 * ONLY the `/ab-vault/candidate-assignments` screen; that opt-in wrapper must
 * NOT be added here, or its `--ab*` vars would leak globally.
 */
export const CustomerGlobalStyle = createGlobalStyle`
  :root {
    color-scheme: dark;
  }
`;

interface Props {
  children?: React.ReactNode;
}

const CustomerTheme = ({ children }: Props) => (
  <>
    <CustomerGlobalStyle />
    {children}
  </>
);

export default CustomerTheme;
